function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Path, Circle } from "react-native-svg";
var SvgMenopause = function SvgMenopause(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement(Path, {
    stroke: props.fillLine,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m12 21.368 5.095-5.096a3.09 3.09 0 0 0-2.18-5.286 3.09 3.09 0 0 0-2.187.919l-.728.727-.728-.727a3.088 3.088 0 1 0-4.367 4.367L12 21.368Z"
  }), /*#__PURE__*/React.createElement(Circle, {
    cx: 12,
    cy: 6,
    r: 2.5,
    stroke: props.accentFillLine
  }));
};
export default SvgMenopause;